import ErrorBoundaries from './ErrorBoundaries';

export default ErrorBoundaries;
